import { useStyletron } from "baseui";
import { StyledLink } from "baseui/link";
import { HeadingSmall } from "baseui/typography";
import React from "react";
import type { DocsInterfaceProps } from "../../src/chrome/DocsInterface";
import { DocsInterface } from "../../src/chrome/DocsInterface";
import Landing from "../../src/components/Landing";

const ReferenceLink = ({ title, href, body }: { title: string; href: string; body: React.ReactNode }) => {
  const [css, $theme] = useStyletron();

  return (
    <div
      className={css({
        paddingTop: $theme.sizing.scale300,
        paddingBottom: $theme.sizing.scale300,
        fontFamily: $theme.typography.font200.fontFamily,
        display: "flex",
        flexDirection: "column",
        gap: $theme.sizing.scale400,
      })}
    >
      <StyledLink $style={{ textDecoration: "none", fontSize: "18px" }} href={href}>
        {title}
      </StyledLink>
      <p style={{ color: $theme.colors.primary600, fontSize: "14px" }}>{body}</p>
    </div>
  );
};

const ReferenceLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <Landing title="Reference" contents={["Detailed reference material on Gadget concepts and packages."]}>
        <div className={css({ display: "flex", flexDirection: "column", gap: $theme.sizing.scale800, paddingTop: $theme.sizing.scale800 })}>
          <div style={{ display: "flex", flexDirection: "column", gap: $theme.sizing.scale400 }}>
            <ReferenceLink title="Gadget CLI" href="/reference/ggt" body="Command line tool for building your Gadget app locally." />
            <ReferenceLink title="Gelly" href="/reference/gelly" body="Gadget's high-performance query language." />
            <ReferenceLink title="Metadata files" href="/reference/metadata-files" body="Gadget metadata file definitions." />
          </div>
          <div
            className={css({ paddingTop: $theme.sizing.scale200, display: "flex", flexDirection: "column", gap: $theme.sizing.scale400 })}
          >
            <HeadingSmall paddingTop={$theme.sizing.scale500} paddingBottom={$theme.sizing.scale500}>
              Packages
            </HeadingSmall>
            <ReferenceLink
              title="gadget-server"
              href="/reference/gadget-server"
              body="Utilities for implementing your Gadget app's backend."
            />
            <ReferenceLink title="@gadgetinc/react" href="/reference/react" body="React library for calling your Gadget backend." />
            <ReferenceLink title="@gadgetinc/preact" href="/reference/preact" body="Preact library for calling your Gadget backend." />
            <ReferenceLink title="@gadgetinc/react/auto" href="/reference/react/auto" body="React library for Gadget's autocomponents." />
            <ReferenceLink
              title="@gadgetinc/react-shopify-app-bridge"
              href="/reference/shopify-app-bridge"
              body="Handles automating Shopify OAuth and App Bridge initialization."
            />
            <ReferenceLink
              title="@gadgetinc/shopify-extensions"
              href="/reference/shopify-extensions"
              body="Utilities to help you build Shopify extensions."
            />
            <ReferenceLink
              title="@gadgetinc/react-bigcommerce"
              href="/reference/react-bigcommerce"
              body="Utilities for BigCommerce single-click app OAuth and session management."
            />
            <ReferenceLink
              title="@gadgetinc/react-chatgpt-apps"
              href="/reference/react-chatgpt-apps"
              body="Utilities and hooks for interacting with window.openai and making authenticated requests from ChatGPT apps."
            />
          </div>
        </div>
      </Landing>
    </DocsInterface>
  );
};

export default ReferenceLandingPage;
